import { useStyles } from './styles'

type FireworkProps = {
  isVisible: boolean
}

export const Firework = (props: FireworkProps) => {
  const { isVisible } = props
  const { classes } = useStyles()
  return (
    <iframe
      style={{
        display: isVisible ? 'block' : 'none',
      }}
      className={classes.iframe}
      src="https://lottie.host/embed/2bca4740-8ed3-4ca9-888b-e6e3348caa89/lmZTXP47uz.json"
    />
  )
}
